import useDateFormatter from '@/libraries/formatters/use-date-formatter/use-date-formatter';

interface FlightSelectorFormatTimeProps {
  /** The arrival time */
  arrivalDate: string;
  /** The departure time */
  departureDate: string;
}

export const useFlightSelectorFormatTime = ({
  arrivalDate,
  departureDate,
}: FlightSelectorFormatTimeProps) => {
  const { dateFormatter, dayjs } = useDateFormatter();

  const fromDate = dateFormatter(departureDate);
  const toDate = dateFormatter(arrivalDate);

  // Rikke says that if the hour is 00:00, we don't display it so this is where we handle that.
  const arrivalHourExists = toDate.format('HH:mm') !== '00:00';

  let dateMonth: string;

  if (dayjs.locale() === 'da') {
    dateMonth = fromDate.format('D. MMM').toUpperCase(); // 27. DEC
  } else {
    dateMonth = fromDate.format('D MMM').toUpperCase(); // 27 DEC
  }

  return {
    arrivalHour: arrivalHourExists ? toDate.format('HH:mm') : '',
    date: fromDate.format('D'),
    dateMonth,
    day: fromDate.format('ddd'),
    departureHour: fromDate.format('HH:mm'),
    differenceDays: toDate.diff(fromDate, 'days'),
    differenceHours: toDate.diff(fromDate, 'hours'),
    differenceMinutes: toDate.diff(fromDate, 'minutes') % 60,
    month: fromDate.format('MMM').toUpperCase(),
  };
};
